<div class="flex flex-col h-full bg-(--surface-ground)">
  <!-- Navigation progress bar — fixed at viewport top, above all other elements -->
  @if (isNavigating()) {
    <p-progressbar
      mode="indeterminate"
      class="nav-progress-bar"
      aria-label="Page loading"
    />
  }

  <!-- Top Navigation Bar -->
  <nav class="sticky top-0 z-100 shadow-[0_2px_8px_rgba(0,0,0,0.3)] flex items-center justify-between h-14 px-4 bg-(--p-galaxy-surface-header) border-b border-white/10">
    <!-- Left Section -->
    <div class="flex items-center gap-3 shrink-0">
      <!-- Menu toggle button -->
      <p-button
        icon="pi pi-bars"
        [text]="true"
        (onClick)="toggleSidenav()"
      />

      <!-- App Title -->
      <a routerLink="/" class="block">
        <img src="/images/Galaxy-logo.svg" alt="Galaxy by Beusa Energy" class="h-9 w-auto" />
      </a>
    </div>

    <!-- Right Section -->
    <div class="flex items-center shrink-0 h-full">
      @if (accessService.isGalaxyAdmin()) {
        <button pButton
          [text]="true"
          class="border-0! rounded-none! h-full overflow-visible! transition-colors duration-200 hover:bg-white/10"
          (click)="issuesPopover.toggle($event)"
        >
          <p-overlaybadge [value]="issueBadgeValue()">
            <i class="pi pi-bell text-lg!"></i>
          </p-overlaybadge>
        </button>
        <p-popover #issuesPopover appendTo="body">
          <div class="flex flex-col gap-2 w-80">
            <p class="font-semibold text-color m-0">Pipeline &amp; Connection Issues</p>
            @if (issueNotifications.issues().length === 0) {
              <p class="text-sm text-muted-color m-0">No open issues.</p>
            } @else {
              <div class="flex flex-col gap-2 max-h-80 overflow-y-auto">
                @for (issue of issueNotifications.issues(); track issue.id) {
                  <div class="flex items-start justify-between gap-2 p-2 rounded border border-white/10">
                    <div class="flex flex-col gap-1 min-w-0">
                      <div class="flex items-center gap-2">
                        <p-tag [value]="issue.severity" [severity]="issueSeverity(issue.severity)" />
                        <span class="text-sm font-medium text-color truncate">{{ issue.entityName }}</span>
                      </div>
                      <span class="text-xs text-muted-color">{{ issue.errorCategory }} &middot; {{ issue.occurrenceCount }} occurrences</span>
                    </div>
                    <p-button icon="pi pi-times" [text]="true" size="small" pTooltip="Dismiss"
                              tooltipPosition="left" appendTo="body"
                              (onClick)="dismissIssue(issue.id); issuesPopover.hide()" />
                  </div>
                }
              </div>
            }
            <p-button label="View all issues" [text]="true" size="small"
                      (onClick)="goToIssues(); issuesPopover.hide()" />
          </div>
        </p-popover>
      }
      <button pButton
        [text]="true"
        class="border-0! rounded-none! h-full transition-colors duration-200 hover:bg-white/10"
        (click)="menu.toggle($event)"
      >
        <div class="flex items-center gap-2">
          <div class="hidden sm:flex flex-col items-end max-w-45">
            <span class="font-medium text-md leading-tight text-(--text-color) truncate max-w-full">{{ getUserName() }}</span>
            <span class="text-sm leading-tight text-muted-color truncate max-w-full">{{ getUserEmail() }}</span>
          </div>
          <p-avatar
            [label]="getUserInitials()"
            shape="circle"
            [dt]="{ background: 'var(--p-galaxy-avatar-header)', color: 'white' }"
          />
        </div>
      </button>
      <p-menu #menu [model]="userMenuItems()" [popup]="true" appendTo="body">
        <ng-template #item let-item>
          @if (item.data?.type === 'account') {
            <a pRipple class="flex items-center gap-3 px-3 py-2 cursor-pointer">
              <p-avatar
                [label]="item.data.initials"
                shape="circle"
                class="shrink-0"
                [dt]="{ background: 'var(--p-galaxy-avatar-header)', color: 'white' }"
              />
              <div class="flex flex-col min-w-0">
                <span class="text-sm font-medium text-color leading-tight truncate">{{ item.label }}</span>
                <span class="text-xs text-muted-color leading-tight truncate">{{ item.data.email }}</span>
              </div>
            </a>
          } @else {
            <a pRipple class="flex items-center gap-2 px-3 py-2 cursor-pointer">
              @if (item.icon) {
                <span [class]="item.icon" class="text-sm"></span>
              }
              <span>{{ item.label }}</span>
            </a>
          }
        </ng-template>
      </p-menu>
    </div>
  </nav>

  <!-- Main Container with Sidebar and Content -->
  <div class="flex flex-1 overflow-hidden bg-(--surface-ground)">
    <!-- Sidebar Navigation -->
    <app-sidenav
      [visible]="sidenavVisible()"
      [isMobile]="isMobile()"
      (visibleChange)="sidenavVisible.set($event)"
      (navigate)="onSidenavNavigate()"
    />

    <!-- Main Content Area -->
    <main
      class="flex-1 p-2 md:p-4 overflow-y-auto h-full transition-all duration-300 ease-in-out bg-(--surface-ground)"
      [class.ml-20]="sidenavVisible() && !isMobile()"
      [class.ml-0]="!sidenavVisible() || isMobile()"
    >
      <router-outlet />
    </main>
  </div>

  <!-- Document Viewer Modal -->
  @if (selectedDocumentResult(); as docResult) {
    <app-document-viewer-modal
      [document]="docResult.metadata || null"
      [visible]="showDocumentModal()"
      (visibleChange)="onDocumentModalClose()"
    />
  }

  <!-- Version Mismatch Modal -->
  <app-version-mismatch-modal />

  <!-- Global toast notifications -->
  <p-toast position="bottom-right" />
</div>
